
export class RespBoard {
    constructor({ home, away }) {
        this.home = home||new RespBoardItem({})
        this.away = away||new RespBoardItem({})
    }

    fromJson(jsonData) {
        this.home = new RespBoardItem({})
        this.home.fromJson(jsonData.home)
        this.away = new RespBoardItem({})
        this.away.fromJson(jsonData.away)
    }
}

export class RespBoardItem {
    constructor({ runs, H, R, E }) {
        this.runs = runs||[]
        this.H = H||0
        this.R = R||0
        this.E = E||0
    }

    fromJson(jsonData) {
        this.runs = jsonData.runs
        this.H = jsonData.H
        this.R = jsonData.R
        this.E = jsonData.E
    }
}